module.exports = __webpack_public_path__ + "img/collection-weddingRingsClassic.c6fdad4.jpg";